module.exports = __webpack_public_path__ + "static/dot-line--purple-ecb72448a6e896ba16811697ad28200f.svg";